function linebreakToBr(value) {
  return value ? value.replace(/(?:\r\n|\r|\n)/g, '<br>') : '';
}

function toKebabCase(value) {
  return value
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .toLowerCase();
}

function shorten(text, length) {
  const maxLength = length !== undefined ? length : 80;
  const ellipsisLength = 3;
  if (text.length < maxLength - ellipsisLength) {
    return text;
  }
  const slicedText = text.slice(0, maxLength);
  return `${slicedText}…`;
}

const textFormat = {
  methods: { linebreakToBr, toKebabCase, shorten },
  filters: { linebreakToBr, toKebabCase, shorten },
};

export default textFormat;
